import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import MainForm from "./EmploymentForm/MainForm";
import { useDispatch, useSelector } from "react-redux";
import Footer from "./Footer.js";
import StepCount from "./Common/StepCount";
import {
  getEmployment,
  saveEmploymentAnswer,
  deleteEmploymentAnswer,
} from "../Actions/employmentActions";
import { useParams } from "react-router-dom";
import "../assets/css/candidate-tab-form.css";
import "../assets/css/inner-tabs.css";
import QuestionForm from "../components/EmploymentForm/QuestionForm";
import {
  fresherOptions,
  employmentCountOptions,
} from "./EmploymentForm/empConstants";
import Loader from "./Common/loaderOnlySpinner";
import GetMasterData from "../Helper/masterData";
import { useNavigate } from "react-router-dom";
import CalendarIcon from "../assets/img/calendar-icon.svg";
import TickIconBlack from "../assets/img/tick-icon-black.png";
import CrossIcon from "../assets/img/cross-icon.png";
import CallIcon from "../assets/img/call-icon.png";
import EmailIcon from "../assets/img/email-icon.png";
import ExclamationIcon from "../assets/img/exclation-icon-green.svg";
import UploadIconBlue from "../assets/img/upload-icon-blue.svg";
import ABUploadEdu from "./Common/ABUploadEdu";
import FeatherIcon from "feather-icons-react";
import "../assets/css/custom-modal.css";
import { getArn } from "../Actions/downloadArnAction";
import { getArnUpload } from "../Actions/uploadArnAction";
import { FileUploader } from "react-drag-drop-files";
import { getdeleteFile } from "../Actions/deleteFileAction";
import { getSaveAuth } from "../Actions/saveAuthAction";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import CandidateTabClient from "./CandidateTabClient";
import { deleteLandingClient } from "../Actions/landingClientAction";
import { getQualification } from "../Actions/qualificationAction";
import ProgressHeading from "./Common/ProgressHeading.jsx";

const Authorization = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loading } = autoLoginStore;
  const [showFileUploadModal, setShowFileUploadModal] = useState(true);
  const [showArn,setShowArn]=useState(0);
  const [fileName, setFileName] = useState();
  const [fileSize, setFileSize] = useState();
  const [role, setRole] = useState();
  const [refNo, setRefNo] = useState();
  const [linkAuth, setLinkAuth] = useState(0);
  const [withoutArn, setWithoutArn] = useState(0);
  const [fileUpload, setFileUpload] = useState(0);
  const [viewPopUp, setViewPopUp] = useState(false);
  const [fileFormatAccept, setFileFormatAccept] = useState(false);
  const [referenceNo, setReferenceNo] = useState();
  const storeFileUploadData = useSelector((state) => state.uploadArn);
  let { activeTab, reference } = useParams();
  const [popUpScreen, setPopUpScreen] = useState(false);

  const userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

  const {
    ArnUploadData,
    loading: loadingFileUpload,
    error: errorFileUpload,
  } = storeFileUploadData;

  console.log(ArnUploadData);

  const storeDiySidebarData = useSelector((state) => state.landingClient);
  const { landingClientData, loadingSaveAuthData, errorSaveAuthData } =
    storeDiySidebarData;

  useEffect(() => {
    if (
      typeof landingClientData?.data !== "undefined" &&
      landingClientData?.data !== null
    ) {
      if (landingClientData.data.authrize_complete == 1) {
        navigate(
          `../../case-initiation/check-detail/${landingClientData.data.candidate.reference_number}/candidate-profile`
        );
      }
    }
  }, [landingClientData, storeDiySidebarData]);

  useEffect(() => {
    console.log("ffffffffffff");
    dispatch(getQualification());
  }, []);

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      console.log(" auto login data....", autoLoginData)
      setRole(autoLoginData.data.user_role);
      setShowArn(autoLoginData.data.is_send_arn_link);
      localStorage.setItem(
        "Name",
        JSON.stringify(autoLoginData.data.user_name)
      );
      setReferenceNo(autoLoginData.data.reference_number);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    if (
      typeof ArnUploadData?.status !== "undefined" &&
      ArnUploadData?.status !== null
    ) {  
      const arnDocIds = Object.entries(ArnUploadData.data).map(doc => doc[1].document_id);
      setRefNo(arnDocIds || null);
    }
  }, [ArnUploadData, storeFileUploadData]);

  const handleDownloadArn = () => {
    dispatch(getArn());
  };

  const handleChange = (file) => {
    console.log(file);
    // setFile(file);
    setFileName(file.name);
    setFileSize(file.size);
    let fileType = file.name.split(".");
    console.log("filetype at authrorization",fileType[fileType.length-1]);
    if (
      fileType[fileType.length-1] == "pdf" ||
      fileType[fileType.length-1] == "png" ||
      fileType[fileType.length-1] == "jpg" ||
      fileType[fileType.length-1] == "jpeg"
    ) {
      setFileFormatAccept(true);
    } else {
      alert("file format not correct");
      setFileFormatAccept(false);
      return false;
    }
    setFileSize(Math.round(file.size / 1000));
    //  console.log(file);

    if (file.size > 5242880) {
      alert("File cannot be larger than 5mb");
      setFileFormatAccept(false);
      return false;
    }
    setFileUpload(1);
    dispatch(getArnUpload(file));
    setShowFileUploadModal(false);
  };

  const handleTrashClick = () => {
    setFileFormatAccept(false);
    setShowFileUploadModal(true);
    setFileName("");
    setFileSize("");
    let record = refNo;
    // setFile({});
    setFileUpload(0);
    dispatch(getdeleteFile(record));
    setRefNo("");
  };

  const renderDragDropChildren = () => (
    <>
    <div class="row ml-0">
      <div for="test1" class="col-md-4 upload-box mb-0 flex-column pt-2 pb-2 ">
        <img src={UploadIconBlue} class="mb-1" alt="" />
        <div class="mb-0 text-center" style={{ lineHeight: "16px" }}>
          <div class="right text-right w-100">
            <div class="position-relative">
              <input
                id="test1"
                type="file"
                accept="image/png, image/jpeg, application/pdf"
                multiple=""
                title="Choose Files"
                style={{ opacity: "0", width: "100%" }}
              />
            </div>
          </div>
          <small class="text-center">
            <span class="text-primary fnt-sml-md fnt-inter-mdum">
              Click to upload <span class="text-muted">or drag and drop</span>
            </span>
            <br />
            <span class="text-muted fnt-sml mt-1">
              PDF, JPG, PNG, JPEG formats preferred
            </span>
          </small>
        </div>
      </div>
      {/* <div className="col-md-4">
                    <p class="btn btn-link text-primary mt-4">
                      <FeatherIcon icon="download" class="mr-2" />
                      <span onClick={handleDownloadArn}>
                        Download ARN Template
                      </span>
                    </p>
                  </div> */}
      </div>
    </>
  );

  const handleSave = (e) => {
    e.preventDefault();
    let record = {};
    record.ref = refNo;
    record.lateArn = withoutArn;
    record.candLink = linkAuth;
    if (withoutArn == 1 || linkAuth == 1) {
      record.ref = "";
    }
    dispatch(getSaveAuth(record));
    dispatch(deleteLandingClient());
    navigate(
      `../../case-initiation/check-detail/${referenceNo}/candidate-profile`
    );
  };

  const handleWithoutArn = (e) => {
    if (e.target.checked == true) {
      handleTrashClick();
      setWithoutArn(1);
    } else {
      setWithoutArn(0);
      setLinkAuth(0);
    }
  };

  const handleLinkCandidate = (e) => {
    console.log(e);
    if ( e.target.id == "till_date_2163641" ) {

     if(document.getElementById("till_date_2163111").checked==true){
      document.getElementById("till_date_2163111").checked=false;
     }
      console.log("we",document.getElementById("till_date_2163111").checked);
      handleTrashClick();
      setLinkAuth(!linkAuth);
      setWithoutArn(0);
    } else if(e.target.id == "till_date_2163111"){
      if(document.getElementById("till_date_2163641")?.checked==true){
        document.getElementById("till_date_2163641").checked=false;
       }
      handleTrashClick();
      setWithoutArn(!withoutArn);
      setLinkAuth(0);
    }
     else {
      setWithoutArn(0);
      setLinkAuth(0);
    }
  };

  return (
    <>
      <NotificationPanels />
      {role == "EP" ? <ClientHeader /> : ""}
      {role == "EP" ? <ClientSideBar /> : <Sidebar />}
      {/* <Sidebar/> */}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
            <ProgressHeading/>

              <CandidateTabClient activeTab={"Authorization"} />
            </div>
            <div className="col bg-gray-mbl">
              {/*Form*/}

              <form
                className="p-3 form2 form-section"
                style={{ minHeight: "700px" }}
              >
                <StepCount activeTab={"Employment Details"} />
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h2 className="fnt-smi-bld">Authorization</h2>
                    <p className="text-muted mb-0">
                      Give individual Authorisation before proceeding
                    </p>
                  </div>
                </div>
                <hr />
                <h6 className="fnt-smi-bld">Upload Authorization</h6>
                <p className="text-muted">Upload individual’s authorization</p>

                {showFileUploadModal == true &&
                withoutArn == 0 &&
                linkAuth == 0 ? (
                  <FileUploader
                    hoverTitle={"Choose Files"}
                    classes={"file-upload w-100 border-0"}
                    handleChange={handleChange}
                    multiple={false}
                    name="file"
                    children={renderDragDropChildren()}
                    onSizeError={(file) => {
                      alert("file size larger than 5 mb");
                    }}
                    // onTypeError={(file) => {
                    //   alert("Invalid file format");
                    // }}
                    onClick={(e) => (e.target.value = null)}
                    // types={fileTypes}
                  />
                ) : (
                  ""
                )}

                {showFileUploadModal == true &&
                (withoutArn == 1 || linkAuth == 1) ? (
                  <FileUploader
                    hoverTitle={"Choose Files"}
                    classes={"file-upload w-100 border-0"}
                    handleChange={handleChange}
                    multiple={false}
                    name="file"
                    disabled="true"
                    children={renderDragDropChildren()}
                    onSizeError={(file) => {
                      alert("file size larger than 5 mb");
                    }}
                    // onTypeError={(file) => {
                    //   alert("Invalid file format");
                    // }}
                    onClick={(e) => (e.target.value = null)}
                    // types={fileTypes}
                  />
                ) : (
                  ""
                )}
                <div className="row ml-0">
                  <div className="col-md-4">
                    <div className="form-group">
                      {/* <label for="test1" class="upload-box mb-0 flex-column pt-2 pb-2">
                        <img src={UploadIconBlue} class="mb-1" alt=""/>
                        <label class="mb-0 text-center" style={{lineHeight: '16px'}}>
                          <div class="right text-right w-100"><div class="position-relative">
                            <input id="test1" type="file" accept="image/png, image/jpeg, application/pdf" multiple="" title="Choose Files" style={{opacity: '0', width: '100%'}}/>
                          </div>
                        </div>
                        <small class="text-center">
                          <span class="text-primary fnt-sml-md fnt-inter-mdum">Click to upload <span class="text-muted">or drag and drop</span>
                        </span>
                          <br/>
                          <span class="text-muted fnt-sml mt-1">PDF, JPG, PNG, JPEG formats preferred</span>
                        </small>
                      </label>
                      </label> */}

                      {fileFormatAccept == true ? (
                        <div class="upload-box-has-file">
                          <div class="d-inline-flex align-items-center">
                            <span class="blue-icon-box float-left sml mr-2">
                              <FeatherIcon icon="file" width="12" />
                            </span>
                            <span>
                              <span class="title fnt-inter-mdum upload-box-title">
                                {fileName}
                              </span>
                              <p class="text-muted fnt-sml-md mb-0">
                                {fileSize} KB – 100% uploaded
                              </p>
                            </span>
                          </div>
                          <FeatherIcon
                            icon="trash-2"
                            width="26"
                            onClick={handleTrashClick}
                            className="text-muted cursor-pointer"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-md-4" style={{position:"absolute", top:"24%",right:"29%"}}>
                    <p class="btn btn-link text-primary mt-4">
                      <FeatherIcon icon="download" class="mr-2" />
                      <span onClick={handleDownloadArn}>
                        Download ARN Template
                      </span>
                    </p>
                  </div>
                </div>

                

             {showArn == 1 ? <> 
              <h6 className="fnt-smi-bld">OR</h6>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="till_date"
                      id="till_date_2163641"
                      data-checkdetailsindex="0"
                      data-fieldname="till_date"
                      onClick={handleLinkCandidate}
                    />
                    <label
                      for="till_date_2163641"
                      class="form-check-label-2 fnt-sml-md"
                    >
                      Send link to candidate to sign digital authorization form
                    </label>
                    {linkAuth == 1 && withoutArn == 0 ? <p class="text-danger fnt-sml">Note: The link to sign the ARN and OTP on mobile number will be sent to candidate on the details (email and mobile number) filled in the profile form.</p>:""}
                  </div>
                {/* <input type="checkbox" class="form-check-input" name="till_date_2163640" id="till_date_2163640" data-checkdetailsindex="0" data-fieldname="till_date" onClick={handleLinkCandidate}/>
                  <label for="till_date_2163640" class="form-check-label fnt-sml-md">Send link to candidate to sign digital authorization from</label>
                <p class="text-danger mt-3 fnt-sml">Disclaimer: The link to sign the ARN and OTP on mobile number will be sent to candidate on the details (email and mobile number) filled in the profile form.</p> */}
                
                {userLocalData?.client_id == "411448" || userLocalData?.client_id == "471624" ? <></> : <h6 className="fnt-smi-bld">OR</h6>}
                </>:""}

                {/* {showArn == 1 ? <>  */}
                {
                  userLocalData?.client_id == "411448" || userLocalData?.client_id == "471624"
                  ? <></> 
                  : <div class="form-check mb-3">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    name="till_date"
                    id="till_date_2163111"
                    data-checkdetailsindex="0"
                    data-fieldname="till_date"
                    onClick={handleLinkCandidate}
                  />
                  <label
                    for="till_date_2163111"
                    class="form-check-label fnt-sml-md"
                  >
                    Continue without uploading ARN
                  </label>
                {withoutArn == 1 && linkAuth ==0 ? <p class="text-danger fnt-sml">Disclaimer: By selecting this option and initiating the verification for the candidate, you undertake that the candidate has been informed and has consented to his/her background verification being conducted and you agree to take full responsibility of such consent and any breach of any applicable law thereof. In case candidate is an EU data subject, they know and have been informed about their rights (Data Subject Rights) with respect to processing of their personal data, subject to conditions and restrictions set out in the applicable laws.</p>:""}
                </div>
                }
                {/* </>:""} */}
                {/* <input type="checkbox" class="form-check-input" name="till_date_2163640" id="till_date_2163640" data-checkdetailsindex="0" data-fieldname="till_date" onClick={handleWithoutArn}/>
                  <label for="till_date_2163640" class="form-check-label fnt-sml-md">Continue without uploading ARN</label>

                <p class="text-danger mt-3 fnt-sml">Disclaimer: By selecting this option and initiating the verification for the candidate, you undertake that the candidate has been informed and has consented to his/her background verification being conducted and you agree to take full responsibility of such consent and any breach of any applicable law thereof. In case candidate is an EU data subject, they know and have been informed about their rights (Data Subject Rights) with respect to processing of their personal data, subject to conditions and restrictions set out in the applicable laws.</p> */}

                <span class="fnt-sml" style={{cursor:"pointer"}}>
                  <u class="text-drak mb-3" onClick={() => setViewPopUp(true)}>
                    View Data subject Rights
                  </u>
                </span>
              {linkAuth ==1 || withoutArn == 1 ?"": <p class="text-danger mt-3 fnt-sml">
                  Disclaimer: Please ensure that the Authorization you have
                  uploaded is duly signed by the candidate. In the event of you
                  providing us with any unsigned Authorization or any irrelevant
                  document for initiating the verification for the candidate,
                  you undertake that you have informed candidate about his/her
                  verification, privacy rights (In case candidate is a EU data
                  subject ) and have obtained the validly signed. Authorization
                  of the candidate and hereby agree to take full responsibility
                  of complying with and any breach of applicable law thereof.
                </p>}

                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    {/* <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">Back</button> */}
                    {fileUpload == 1 || withoutArn == 1 || linkAuth == 1 ? (
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={handleSave}
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                   //     disabled
                        onClick={handleSave}
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
              </form>

              {/*Form*/}
              <div className="mt-4">
                <div className="row mb-3">
                  {/* <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    <button className="btn btn-primary btn-lg mr-3">
                      Submit for Preview
                    </button> 
                    <span className="text-muted">
                      Please complete the all mandatory fields before final
                      submission
                    </span>
                  </div> */}
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </section>

      {viewPopUp == true ? (
        <div className="custom-modal-dialog show" id="">
          <div className="modal-wrapper">
            <span class="close-icon">
              <FeatherIcon icon="x" onClick={() => setViewPopUp(false)} />
            </span>
            <div className="modal-content p-4" id="">
              <img src={ExclamationIcon} alt="" width="48" class="mb-3" />
              <h5 className="fnt-smi-bld mb-3">View Data Subject Right</h5>
              <p class="fnt-sml">
                To withdraw/ update/ delete your consent for AuthBridge to
                process your personal data or request to update/delete your
                Personal Data, we encourage you to speak to your
                Employer/AuthBridge's client you have engagement with upon their
                request, your request will be withdrawn, or personal data will
                be updated/deleted. Upon receiving such requests, AuthBridge
                will immediately act upon the same.
                <br />
                <br />
                <span class="fnt-smi-bld d-block">
                  Rights for EU Data Subjects
                </span>
                <br />
                If you are an EU (European Union) subject, you have the
                following rights with respect to your Personal Data that we
                process, subject to conditions and restrictions set out in the
                applicable laws-
                <br />
                <br />
                to learn whether your Personal Data is processed by us and to
                request a copy of your Personal Data and information relating to
                the processing of your Personal Data
                <br />
                <br />
                <ul>
                  <li>
                    to request the correction of any inaccurate or incomplete
                    Personal Data
                  </li>
                  <li>
                    to request the erasure of your Personal Data or the
                    restriction of the processing of your Personal Data
                  </li>
                  <li>to object to our processing of your Personal Data</li>
                  <li>to withdraw your consent, you have given</li>
                  <li>
                    to lodge a complaint with the applicable regulatory/
                    supervisory authority
                  </li>
                </ul>
                If you are an AuthBridge client, please write to us on the email
                id/ address provided in Contact us section given below.
                <br />
                <br />
                If your Personal Data is being processed by AuthBridge as a
                third party for your Background verification, and you wish to
                exercise any of your rights under the applicable law, we request
                you to reach out to your employer/AuthBridge's client you have
                engagement with. On receiving the communications from its
                clients about your request, AuthBridge will immediately act upon
                the same in accordance with the applicable law.
              </p>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {popUpScreen == false ? (
        <div className="custom-modal-dialog show" id="">
          <div className="modal-wrapper">
            <span onClick={() => setPopUpScreen(true)} class="close-icon mr-2">
              <FeatherIcon icon="x" />
            </span>
            <div className="modal-content p-4 no-scroll" id="">
              <img src={ExclamationIcon} alt="" width="48" class="mb-3" />
              <h5 className="fnt-smi-bld mb-3">Instructions</h5>
              <p class="fnt-sml">
                <ol class="instruction-list">
                  <li>
                    Information you provide in this form shall be used for
                    verification purpose. You are advised to fill this form with
                    utmost care and attention.
                  </li>
                  <li>
                    Documents provided as proof for the details should match
                    with the information you enter.
                  </li>
                  <li>
                    Any Mismatch of details in Background Verification Form &
                    the documents may result in rejection of your form for
                    background Verification.
                  </li>
                  <li>Documents in JPEG format are preferable.</li>
                  <li>
                    Maximum document upload size is 5 MB, you can compress your
                    documents from below URL:
                  </li>
                  <ul class="p-0">
                    <li>
                      Image File
                      <a href="https://Optimizilla.com" target="blank">
                        {" "}
                        <span class="text-primary">Optimizilla.com</span>
                      </a>
                    </li>
                    <li>
                      PDF File{" "}
                      <a href="https://pdfcompressor.com" target="blank">
                        {" "}
                        <span class="text-primary">pdfcompressor.com</span>
                      </a>
                    </li>
                  </ul>
                  <li>
                    Please watch iBridge Tutorial video here:  <a href="https://www.youtube.com/watch?v=HdN-U836qG0" target="blank">iBridge Tutorial</a>
                  </li>
                </ol>
              </p>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default Authorization;
